export default "__VITE_ASSET__69e59373__"